import PaymentPage from './payment-page';

export default PaymentPage;
